import { List as IList, Map as IMap } from 'immutable';
import { createSelector } from 'reselect';

export const getFees = state => state.get('fees', IMap());

export const getConsumerFees = createSelector(
    getFees,
    fees => fees.get('consumerFees', IList())
);

export const getFeesCurrencyCode = createSelector(
    getFees,
    fees => fees.get('currencyCode', null)
);

export const getActivationFeeAmount = (state, feeType) => {
    const consumerFees = getConsumerFees(state);

    const feeEntry = consumerFees.find(fee => fee.get('type') === feeType);

    if (feeEntry && feeEntry.get('tiers') && feeEntry.get('tiers').size > 0) {
        return feeEntry.getIn(['tiers', 0, 'amount']);
    }

    return null;
};
